

import { VideoLessionProgram } from "../schoolPrograms/videoLessionProgram/videoLessionProgram";
import { Facilitator } from "./facilitator";


export const FacilitatorVideoLessionFile = () => {

    return (<>
        <Facilitator>
            <VideoLessionProgram isAddFilesVisible={true} isDeleteFilesVisible={true} />

        </Facilitator>
    </>);
}